import React, { ReactElement } from 'react';
import { Routes, Route } from 'react-router-dom';

import LoginContainer from './login/Login.container';
import ActivateContainer from './activate/Activate.container';
import ForgotPasswordContainer from './forgot-password/ForgotPassword.container';
import ResetPasswordContainer from './reset-password/ResetPassword.container';
import RegistrationContainer from './registration/Registration.container';
import ProgrammeDetailsContainer from './programme-details/ProgrammeDetails.container';
import RegistrationSuccessContainer from './registration-success/RegistrationSuccess.container';
import DeleteAccountContainer from './delete-account/DeleteAccount.container';

const AuthContainer = (): ReactElement => (
  <Routes>
    <Route path="/" element={<LoginContainer />} />
    <Route path="/activate/:memberExternalReference" element={<ActivateContainer />} />
    <Route path="/forgot-password" element={<ForgotPasswordContainer />} />
    <Route path="/reset-password/:contactPointExternalReference" element={<ResetPasswordContainer />} />
    <Route path="/register" element={<RegistrationContainer />} />
    <Route path="/register/:externalReference" element={<ProgrammeDetailsContainer />} />
    <Route
      path="/register/success/:programmeExternalReference/:memberExternalReference"
      element={<RegistrationSuccessContainer />}
    />
    <Route path="/delete-account" element={<DeleteAccountContainer />} />
  </Routes>
);

export default AuthContainer;
